// The i18n context is shared (@booking/core-ui/i18n). This module registers the
// per-vertical dictionaries at load, then re-exports the shared context so the
// rest of admin keeps importing from "@/lib/i18n/context" unchanged.
import { registerDictionaries } from "@booking/core-ui/i18n";
import ja from "./ja";
import en from "./en";

registerDictionaries({ ja, en });

export * from "@booking/core-ui/i18n";
